
import { useCallback, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { listadoMisClientes, listadoUsuariosRol, usuarioPorID } from "../../../services";



export const useUsuarioXID = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ['user-id', { id }], 
        queryFn: () => usuarioPorID(id),
        enabled: !!id,
    });

    return { data, isLoading }
}




export const useListUserXRole = (rol) => {
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['user-xrole', { page, termino, rol }], 
        queryFn: () => listadoUsuariosRol({ page, termino, rol }),
    });

    const chagePage = useCallback((num) => {
        setPage(num - 1);
    }, [])


    const chageTermino = useCallback((valor) => {
        setPage(0);
        setTermino(valor)
    }, [])

    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        data, isLoading,
    }
}






export const useListMisClientes = () => {
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['me-clientes', { page, termino }], 
        queryFn: () => listadoMisClientes({ page, termino }),
    });

    const chagePage = useCallback((num) => {
        setPage(num - 1);
    }, [])


    const chageTermino = useCallback((valor) => {
        setPage(0);
        setTermino(valor)
    }, [])

    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        data, isLoading,
    }
}

